import {GameStateEnums} from '../../../../../../shared/GameEnums'
import {UIGameMechanic} from '../../UIGameEventController'
import {UIGameManager} from '../../UIGameManager'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {BeginnerModeConstants, HiddenUIElement, getWaitMSForAction} from '@colonist/game-beginner-mode'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {UIGameDiceNumberAnimationController} from '../../ui_game_dice/UIGameDiceNumberAnimationController'
import {UIGameDiceView} from '../../ui_game_dice/UIGameDiceView'

export class UIGameBeginnerModeDiceHelper implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly diceNumberAnimationController: UIGameDiceNumberAnimationController

    private diceHiddenPermanently: boolean
    private diceNumberAnimationWaitMS: number = BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.diceNumberAnimationController = new UIGameDiceNumberAnimationController(this.uiGameManager)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            default: break
        }
    }

    startDiceNumberAnimation(diceView: UIGameDiceView) {
        this.diceNumberAnimationController.startDiceNumberAnimation(diceView, this.diceNumberAnimationWaitMS)
    }

    get isDiceHiddenPermanently() {
        return this.diceHiddenPermanently
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        this.diceNumberAnimationWaitMS = getWaitMSForAction(BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION, data.actionIndex)

        const isHidden: boolean = data.hiddenUIElements.includes(HiddenUIElement.Dice)
        if(isHidden) return this.diceHiddenPermanently = true

        this.diceHiddenPermanently = false
        return
    }
}
